// The text of a game card that this player sees: the one in the screen language, else the card's first text.
// An answer text is {lang, text}, a question text {lang, parts}; a written card's one text has no lang.
import { currentLanguage } from '.';

export const displayText = card => card.texts.find(text => text.lang === currentLanguage()) ?? card.texts[0];
